<template lang="pug">
.category-filter
  v-autocomplete.nowrap(
    v-model="lazyValue"
    attach
    clearable
    multiple
    outlined
    dense
    item-value="id"
    item-text="displayName"
    :items="lazyCategories"
    :label="$t($lang.content.CATEGORY)"
    :search-input.sync="search"
    :filter="customFilter"
    @change="clearSearch"
    @input="onChanged"
  )
</template>
<script>
import {
  ref, onMounted, watch, computed,
} from 'vue';
import { useSelectedSorter } from '@/helpers/misc';
import { useModelBinding } from '@/helpers/misc/binding';
import { filterSelectedValues } from '@/helpers/content';
import toLink from '@/helpers/toLink';
import { useSiteProvider } from '@/helpers/site';
import { getCategories } from '@/api/category/CategoryApi';

export default {
  name: 'Category',
  props: {
    value: {
      type: Array,
    },
    selectedSiteId: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { sites } = useSiteProvider();

    const lazyItems = ref([]);
    const search = ref('');
    const filter = ref({ isApproved: true });

    const clearSearch = () => {
      search.value = '';
    };

    const { lazyValue, updateValue } = useModelBinding(emit, props);

    const onChanged = () => {
      if (!props.multiple && lazyValue.value.length > 1) {
        lazyValue.value = [lazyValue.value[lazyValue.value.length - 1]];
      }

      updateValue(lazyValue.value);
    };

    const fetch = async () => {
      lazyItems.value = await getCategories(filter.value);
    };

    onMounted(async () => {
      await fetch();
    });

    const [lazyCategories] = useSelectedSorter(lazyItems, lazyValue, filterSelectedValues, 'id');

    const selectedSiteLocale = computed(() => sites.value.find(site => site.id === props.selectedSiteId)?.language);
    const customFilter = (item, queryText) => {
      const displayNameText = toLink(item.displayName, selectedSiteLocale.value);
      const searchText = toLink(queryText, selectedSiteLocale.value);

      return displayNameText.indexOf(searchText) > -1;
    };

    watch(() => props.selectedSiteId, async newValue => {
      lazyItems.value = await getCategories({ ...filter.value, ...(newValue ? { siteId: newValue } : {}) });
      search.value = '';
    });

    return {
      search,
      lazyValue,
      lazyItems,
      lazyCategories,
      fetch,
      clearSearch,
      customFilter,
      onChanged,
    };
  },
};
</script>
